import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import ProtectedRoute from './routes/ProtectedRoute';
import UploadDocuments from './pages/UploadDocuments';
import ReportPage from './pages/ReportPage';
import SummaryPage from './pages/SummaryPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import VendorMismatchDetailPage from './pages/VendorMismatchDetailPage';
import MismatchedSummaryPage from './pages/MismatchedSummaryPage';
import Reconciled from './pages/reconciled';
import PaidInvoiceDetailPage from './pages/paidinvoice';
import StateMasterPage from './pages/state';
import GstMasterPage from './pages/gst';
import SupplierTypeMasterPage from './pages/suppliertype';
import UserMasterPage from './pages/UserMasterPage';
import RoleMasterPage from './pages/RoleMasterPage';
import HomePage from './pages/homepage';
import MismatchFormInvoiceSummary from './pages/mismatchedform2b';
import Form2BDetailPage from './pages/form2bdetailspage';
import DebitSummaryPage from './pages/DeditSummaryPage';
import DebitDetailPage from './pages/DebitDetailPage';
import AllInvoicePage from './pages/AllinvoicePage';
import All2BPage from './pages/All2BPage';
import ProcessInvoicePage from './pages/processinvoicepage';
import InvoiceAuditLogReport from './pages/invoiceauditpage';
import Form2BAuditLogReport from './pages/Form2BAuditLogReport';
import InvoiceAuditLogDetailsPage from './pages/InvoiceAuditLogDetailsPage';
import Form2BAuditDetailsPage from './pages/Form2BauditDetailsPage';
// import UploadGstEmails from './pages/UploadGstEmails';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/home"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/upload"
          element={
            <ProtectedRoute>
              <UploadDocuments />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/report"
          element={
            <ProtectedRoute>
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/missmatchedreport"
          element={
            <ProtectedRoute>
              <MismatchedSummaryPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/summarypage"
          element={
            <ProtectedRoute>
              <SummaryPage />
            </ProtectedRoute>
          }
        />


        <Route 
          path="/form2bmissinginv"
          element={
            <ProtectedRoute>
              <MismatchFormInvoiceSummary />
            </ProtectedRoute>
          }
        />
        
        <Route 
          path="/paidsummarypage"
          element={
            <ProtectedRoute>
              <Reconciled />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/master/state"
          element={
            <ProtectedRoute>
              <StateMasterPage />
            </ProtectedRoute>
          }
        />


        <Route 
          path="/master/gst"
          element={
            <ProtectedRoute>
              <GstMasterPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/master/suppliertype"
          element={
            <ProtectedRoute>
              <SupplierTypeMasterPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/master/user"
          element={
            <ProtectedRoute>
              <UserMasterPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/master/role"
          element={
            <ProtectedRoute>
              <RoleMasterPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/invoice-details/:gstid"
          element={
            <ProtectedRoute>
              <InvoiceDetailPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/paidinvoice-details/:gstid"
          element={
            <ProtectedRoute>
              <PaidInvoiceDetailPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/form2b-details/:gstid"
          element={
            <ProtectedRoute>
              <Form2BDetailPage />
            </ProtectedRoute>
          }
        />


        <Route 
          path="/vendor-mismatch/:gstid"
          element={
            <ProtectedRoute>
              <VendorMismatchDetailPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/debit_summary_page"
          element={
            <ProtectedRoute>
              <DebitSummaryPage />
            </ProtectedRoute>
          }
        />


        <Route 
          path="/debit_note_details/:gstid"
          element={
            <ProtectedRoute>
              <DebitDetailPage />
            </ProtectedRoute>
          }
        />

        
        <Route 
          path="/pending_itc"
          element={
            <ProtectedRoute>
              <AllInvoicePage/>
            </ProtectedRoute>
          }
        />

        <Route 
          path="/pending_2B"
          element={
            <ProtectedRoute>
              <All2BPage/>
            </ProtectedRoute>
          }
        />


        <Route 
          path="/process_itc"
          element={
            <ProtectedRoute>
              <ProcessInvoicePage/>
            </ProtectedRoute>
          }
        />

        <Route 
          path="/invoice_audit_log"
          element={
            <ProtectedRoute>
              <InvoiceAuditLogReport/>
            </ProtectedRoute>
          }
        />

        <Route 
          path="/form2b_audit_log"
          element={
            <ProtectedRoute>
              <Form2BAuditLogReport/>
            </ProtectedRoute>
          }
        />


        <Route 
         path="/invoice-audit-details/:auditLogId"
          element={
            <ProtectedRoute>
              <InvoiceAuditLogDetailsPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/form2b-auditlog-details/:auditLogId"
          element={
            <ProtectedRoute>
              <Form2BAuditDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* <Route 
          path="/upload_email"
          element={
            <ProtectedRoute>
              <UploadGstEmails />
            </ProtectedRoute>
          }
        /> */}

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
